import { Link } from "react-router-dom";
import { ShieldCheck, Truck, Award, PhoneCall } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-24">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 bg-emerald-500 flex items-center justify-center rounded-sm">
              <ShieldCheck className="w-5 h-5 text-slate-900" />
            </div>
            <span className="font-display font-black text-lg text-white">MedSupply Pro</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Premium hospital-grade supplies delivered direct from certified distributors.
            No-touch freight. Verified quality. Enterprise pricing.
          </p>
        </div>

        <div>
          <p className="overline text-emerald-400 mb-4">Shop</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-white">All products</Link></li>
            <li><Link to="/category/ppe" className="hover:text-white">PPE</Link></li>
            <li><Link to="/category/gloves" className="hover:text-white">Gloves</Link></li>
            <li><Link to="/category/sanitary" className="hover:text-white">Sanitary</Link></li>
            <li><Link to="/category/diagnostics" className="hover:text-white">Diagnostics</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline text-emerald-400 mb-4">Company</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/account" className="hover:text-white">My orders</Link></li>
            <li><Link to="/shop" className="hover:text-white">Bulk pricing</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline text-emerald-400 mb-4">Trust</p>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Truck className="w-4 h-4 text-emerald-400"/> Free freight over $150</li>
            <li className="flex items-center gap-2"><Award className="w-4 h-4 text-emerald-400"/> Certified distributors</li>
            <li className="flex items-center gap-2"><PhoneCall className="w-4 h-4 text-emerald-400"/> Human support M-F</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6 text-xs text-slate-500 text-center">
        © {new Date().getFullYear()} MedSupply Pro. All rights reserved. Products for professional and institutional use.
      </div>
    </footer>
  );
}
